import { createRouter, createWebHashHistory } from 'vue-router'
import TheDashBoard from '../components/dashboard/TheDashBoard.vue'
import TheLogin from '../components/authentication/TheLogin.vue'
import TheLogout from '../components/authentication/TheLogout.vue'
import ThePreloader from '../components/dashboard/ThePreloader.vue'
// import TheChangePersonalInfo from '../components/user/TheChangePersonalInfo.vue'
import TheChangePassword from '../components/authentication/TheChangePassword.vue'
import TheChangeInformation from '../components/authentication/TheChangeInformation.vue'
import TheLoggedInLayout from '../components/dashboard/TheLoggedInLayout.vue'

import TheTreeMenu from '@/components/dashboard/TheTreeMenu.vue'
// import TheLeafletMap2 from '../components/maps/TheLeafletMap2.vue'
// import TheLeafletMap3 from '../components/maps/TheLeafletMap3.vue'
import TheError404 from '../components/dashboard/TheError404.vue'
import { store } from '@/store'
import config from '@/config/prod.env'
import { authenticationService } from '@/services/authentication/authentication.service.js'
import TheDonViQT from '@/components/quantri/TheDonViQT.vue'
import ThePhanHeQT from '@/components/quantri/ThePhanHeQT.vue'
import TheNhomQuyenQT from '@/components/quantri/TheNhomQuyenQT.vue'
import TheQuyenQT from '@/components/quantri/TheQuyenQT.vue'
import TheNguoiDungQT from '@/components/quantri/TheNguoiDungQT.vue'
import TheLichSuDangNhapQT from '@/components/quantri/TheLichSuDangNhapQT.vue' 
import TheThongKeLichSuDangNhapQT from '@/components/quantri/TheThongKeLichSuDangNhapQT.vue' 

import TheTinhTp from '@/components/danhmuc/TheTinhTp.vue'
import TheQuanHuyen from '@/components/danhmuc/TheQuanHuyen.vue'
import ThePhuongXa from '@/components/danhmuc/ThePhuongXa.vue'
import TheKhomAp from '@/components/danhmuc/TheKhomAp.vue'
import TheToDanPho from '@/components/danhmuc/TheToDanPho.vue'
import TheDuongPho from '@/components/danhmuc/TheDuongPho.vue'

import TheDMChucDanh from '@/components/danhmuc/TheChucDanh.vue'
import TheDMCapDonVi from '@/components/danhmuc/TheCapDonVi.vue'

import TheMenu from '@/components/menu/TheMenu.vue'
import TheMenuRoleTree from '@/components/menu/TheMenuRoleTree.vue'
import ThePhanQuyenMenu from '@/components/menu/ThePhanQuyenMenu.vue'


const routes = [
	{
		path: '/:pathMatch(.*)*',
		name: 'TheError404',
		component: TheError404
	},
	{
		path: '/login',
		name: 'TheLogin',
		component: TheLogin,
		props: true,
		meta: {
			authRequired: false,
		},
	},
	// {
	// 	path: '/login2/:appId',
	// 	name: 'TheLogin2',
	// 	component: TheLogin,
	// 	props: true,
	// 	meta: {
	// 		authRequired: false,
	// 	},
	// },
	{
		path: '/logout',
		name: 'TheLogout',
		component: TheLogout,
		props: true,
		meta: {
			authRequired: false,
		},
	},
	{
		path: '/preloader',
		name: 'ThePreloader',
		component: ThePreloader,
		props: true,
		meta: {
			authRequired: true,
		},
	},
	{
		path: '/',
		name: 'TheLoggedInLayout',
		component: TheLoggedInLayout,
		props: true,
		meta: {
			authRequired: true,
		},
		children: [
			{
				path: '/changepassword',
				name: 'TheChangePassword',
				component: TheChangePassword,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/changepersonalinfo',
				name: 'TheChangeInformation',
				component: TheChangeInformation,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/treemenu',
				name: 'TheTreeMenu',
				component: TheTreeMenu,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/dashboard',
				name: 'TheDashBoard',
				component: TheDashBoard,
				props: true,
				meta: {
					authRequired: true,
				},
			},

			{
				path: '/danhmuc/chucdanh',
				name: 'TheDMChucDanh',
				component: TheDMChucDanh,
				props: true,
				meta: {
					authRequired: true,
				},
			},
			{
				path: '/danhmuc/capdonvi',
				name: 'TheDMCapDonVi',
				component: TheDMCapDonVi,
				props: true,
				meta: {
					authRequired: true,
				},
			},

			{
				path: '/danhmuc/tinhtp',
				name: 'TheTinhTp',
				component: TheTinhTp,
				props: true,
				meta: {
					authRequired: true,
				},
			},
			{
				path: '/danhmuc/quanhuyen',
				name: 'TheQuanHuyen',
				component: TheQuanHuyen,
				props: true,
				meta: {
					authRequired: true,
				},
			},
			{
				path: '/danhmuc/phuongxa',
				name: 'ThePhuongXa',
				component: ThePhuongXa,
				props: true,
				meta: {
					authRequired: true,
				},
			},
			{
				path: '/danhmuc/khomap',
				name: 'TheKhomAp',
				component: TheKhomAp,
				props: true,
				meta: {
					authRequired: true,
				},
			},

			{
				path: '/danhmuc/todanpho',
				name: 'TheToDanPho',
				component: TheToDanPho,
				props: true,
				meta: {
					authRequired: true,
				},
			},

			{
				path: '/danhmuc/duongpho',
				name: 'TheDuongPho',
				component: TheDuongPho,
				props: true,
				meta: {
					authRequired: true,
				},
			},

			{
				path: '/quantri/donvi',
				name: 'TheDonViQT',
				component: TheDonViQT,
				props: true,
				meta: {
					authRequired: true,
				},
			},
			{
				path: '/quantri/phanhe',
				name: 'ThePhanHeQT',
				component: ThePhanHeQT,
				props: true,
				meta: {
					authRequired: true,
				},
			},

			{
				path: '/quantri/nhomquyen',
				name: 'TheNhomQuyenQT',
				component: TheNhomQuyenQT,
				props: true,
				meta: {
					authRequired: true,
				},
			},

			{
				path: '/quantri/menu',
				name: 'TheMenu',
				component: TheMenu,
				props: true,
				meta: {
					authRequired: true,
				},
			},

			{
				path: '/quantri/phanquyenmenu/:id',
				name: 'TheMenuRoleTree',
				component: TheMenuRoleTree,
				props: true,
				meta: {
					authRequired: true,
				},
			},

			{
				path: '/quantri/phanquyenmenu',
				name: 'ThePhanQuyenMenu',
				component: ThePhanQuyenMenu,
				props: true,
				meta: {
					authRequired: true,
				},
			},

			{
				path: '/quantri/quyen',
				name: 'TheQuyenQT',
				component: TheQuyenQT,
				props: true,
				meta: {
					authRequired: true,
				},
			},

			{
				path: '/quantri/nguoidung',
				name: 'TheNDQT',
				component: TheNguoiDungQT,
				props: true,
				meta: {
					authRequired: true,
				},
			},



			{
				path: '/quantri/lichsudangnhap',
				name: 'TheLichSuDangNhapQT',
				component: TheLichSuDangNhapQT,
				props: true,
				meta: {
					authRequired: true,
				},
			},

			{
				path: '/thongke/lichsudangnhap',
				name: 'TheThongKeLichSuDangNhapQT',
				component: TheThongKeLichSuDangNhapQT,
				props: true,
				meta: {
					authRequired: true,
				},
			},

		],
	},
]

const router = createRouter({
	history: createWebHashHistory(),
	routes
})

router.beforeEach(async (to, from, next) => {

	let loginId = to.query.login
	if (loginId) {
		let res = await authenticationService.getLoginInfoFromSSO(loginId, config.APPID)
		if (res.code) {
			next('/dashboard')
		}
		else{
			next('/login')
		}

	}
	else {
		let loggedIn = store.state.authentication.status.loggedIn
		let user = JSON.parse(localStorage.getItem('user'))
		if (user && Date.parse(user.expiresTime) > Date.now()) {
			loggedIn = true
		}
		else {
			loggedIn = false
		}
		let authPage = to.meta.authRequired
		if (authPage && !loggedIn) {
			localStorage.removeItem('user')
			localStorage.removeItem('menu')
			//next('/login')
			next('/login')
		}
		else {
			next()
		}
	}
})

export default router
